(function () {
  document.querySelectorAll('.most-trending').forEach((section) => {
    const tabs    = section.querySelectorAll('.most-trending__tab');
    const panels  = section.querySelectorAll('.most-trending__panel');
    const viewAll = section.querySelector('[data-view-all]');
    const arrows  = section.querySelectorAll('.most-trending__arrow');

    const getActiveTrack = () =>
      section.querySelector('.most-trending__panel.is-active [data-track]');

    const syncViewAll = () => {
      const active = section.querySelector('.most-trending__panel.is-active');
      if (active && viewAll && active.dataset.viewAllUrl) {
        viewAll.setAttribute('href', active.dataset.viewAllUrl);
      }
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tabTarget;
        tabs.forEach((t) => t.classList.toggle('is-active', t === tab));
        panels.forEach((p) => p.classList.toggle('is-active', p.id === target));
        syncViewAll();
      });
    });

    arrows.forEach((btn) => {
      btn.addEventListener('click', () => {
        const track = getActiveTrack();
        if (!track) return;
        const dir   = btn.dataset.dir === 'next' ? 1 : -1;
        const card  = track.querySelector('.mt-card');
        const step  = card ? card.getBoundingClientRect().width + 16 : 300;
        track.scrollBy({ left: step * dir * 2, behavior: 'smooth' });
      });
    });

    syncViewAll();
  });
})();